"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDeaf = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12.003 2c2.566 0 4.587 1.078 5.955 2.637l1.914-1.915.364-.364c.465-.46.934-.46 1.405 0 .472.46.475.93.009 1.41l-2.553 2.551A8.16 8.16 0 0120.003 10c0 3.12-1.712 4.188-1.835 5.186-.165 1.334-.42 3.105-.907 3.862C16.32 20.514 14.511 22 12.002 22c0 0-1.012.088-1.012-.979 0-1.066 1.012-1.021 1.013-1.021 1.295 0 2.57-.571 3.708-2.252.635-.94.262-2.152.615-3.538.29-1.135 1.676-2.254 1.676-4.21 0-2.818-2.195-6-6-6-3.804 0-6 3.182-6 6 0 0 0 1-1 1s-1-1-1-1c0-4 2.937-8 8-8zM9.177 7.176a4 4 0 015.657 5.657s-.71.71-1.416.003c-.636-.636-.126-1.276-.018-1.397l.02-.02c.683-.68.897-1.931 0-2.83-.899-.897-2.147-.681-2.83 0 0 0-.709.71-1.417.003-.708-.709.004-1.416.004-1.416zm1.058 5.178l1.415 1.414-7.88 7.878c-.455.477-.924.474-1.406-.008-.483-.482-.485-.951-.008-1.406l7.88-7.878z' }))); };
exports.default = SvgDeaf;
//# sourceMappingURL=Deaf.js.map